import { Directive, ElementRef, HostBinding, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Directive({
  selector: '[appRequiredAsterisk]'
})
export class RequiredAsteriskDirective {

  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() controlName: string = "";
  @HostBinding('class')
  elementClass = '';

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    const isRequired = this.formGroup.controls[this.controlName]?.errors?.required || this.formGroup.controls[this.controlName]?.errors?.min;
    if (isRequired) {
      this.elementRef.nativeElement.innerHTML = '*';
      this.elementClass = "text-danger h5";
    } else {
      this.elementRef.nativeElement.innerHTML = '';
      this.elementClass = "";
    }
  }

}
